export default __webpack_public_path__ + "static/media/logoslide.4d163b7b.png";